var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesktopDollarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8385 7.91428H5.49715C5.17661 7.91428 4.86921 8.04161 4.64256 8.26827C4.4159 8.4949 4.28857 8.80231 4.28857 9.12285V28.46C4.28857 28.7805 4.4159 29.088 4.64256 29.3147C4.86921 29.5412 5.17661 29.6686 5.49715 29.6686H34.5029C34.8234 29.6686 35.1308 29.5412 35.3576 29.3147C35.584 29.088 35.7114 28.7805 35.7114 28.46V26.0428",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5829 29.6686L15.1657 35.7114",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4171 29.6686L24.8343 35.7114",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7486 35.7114H27.2515",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.528 9.6598C35.3866 9.2595 35.1683 8.8955 34.8908 8.58553C34.3008 7.92618 33.4432 7.51123 32.4887 7.51123H29.9939C28.4051 7.51123 27.1172 8.79923 27.1172 10.3881C27.1172 11.74 28.0585 12.9095 29.3792 13.1984L33.1773 14.0293C34.6568 14.3529 35.7114 15.6641 35.7114 17.1786C35.7114 18.9586 34.2686 20.4027 32.4887 20.4027H30.3401C28.9367 20.4027 27.7431 19.5058 27.3005 18.2541",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4142 7.51142V4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4142 23.6259V20.4031",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktopDollarOutline);
export default __webpack_public_path__ + "static/media/icon_desktop_dollar_outline.7282cb01cfec03e884767982f5ed02a7.svg";
export { ForwardRef as ReactComponent };